const colors = {
  primary: '#F46569',
  secondary: '#2B3674',
  'border-grey': '#d9d9d9',
  'placeholder-grey': '#BABABA',
  black: '#191919',
  white: '#FFFFFF',
  blue: '#BEE5FB',
  'light-blue': '#BEE5FBAD',
  'dark-grey': '#454E53',
  grey: '#757575',
  'light-grey': '#0000001A',
  'link-grey': '#A3AED0',
  'dashboard-bg': '#F4F7FE',
  'profile-bg': '#7090B014',
  'participant-blue': '#EEF9FE',
  'auth-bg': '#BDE2F8',
  'primary-light': '#FEF5F6',
  green: '#8EE79D',
  'light-green': '#F6FDF7',
  track: '#f1f1f1',
  thumb: '#888',
  'sidebar-border': '#f7f7f7',
  'times-bg': '#E6E4EB',
  'upload-blue': '#0281C9',
};

module.exports = colors;
